import AccountAllergens from './AccountAllergens'

export default AccountAllergens
